import http from './axios/axios.instance';
import { isApp, requestPushToken } from './bridge';

const USERNAME_KEY = 'offr_username';

function generateUsername() {
  return `user-${Date.now()}`;
}

function getOrCreateUsername() {
  let username = localStorage.getItem(USERNAME_KEY);
  if (!username) {
    username = generateUsername();
    localStorage.setItem(USERNAME_KEY, username);
  }
  return username;
}

function detectInAppBrowser() {
  const ua = (navigator.userAgent || '').toLowerCase();
  if (ua.includes('instagram')) return 'instagram';
  if (ua.includes('fban') || ua.includes('fbav')) return 'facebook';
  if (ua.includes('telegram')) return 'telegram';
  if (ua.includes('tiktok') || ua.includes('bytedancewebview')) return 'tiktok';
  if (ua.includes('twitter')) return 'twitter';
  if (ua.includes('snapchat')) return 'snapchat';
  if (ua.includes('line')) return 'line';
  return null;
}

function detectSource() {
  if (isApp()) {
    return `app.${window.platform || 'unknown'}`;
  }
  const inApp = detectInAppBrowser();
  return inApp ? `web.${inApp}` : 'web';
}

export async function ensureAnonymousAuth() {
  const existingToken = localStorage.getItem('userAuthToken');
  if (existingToken) return;

  const username = getOrCreateUsername();
  const source = detectSource();

  try {
    const response = await http.post('/api/v1/auth/anonymous', { username, source });
    if (response.data) {
      localStorage.setItem('userAuthToken', response.data);
    }
  } catch (error) {
    console.error('Anonymous auth failed:', error);
  }
}

const PUSH_TOKEN_CACHE_KEY = 'offr_push_token';

function buildCacheKey(fcmToken) {
  const authToken = localStorage.getItem('userAuthToken');
  return `${fcmToken}:${authToken}`;
}

export async function registerPushToken() {
  if (!isApp()) return;

  const result = await requestPushToken();
  if (!result?.token) return;

  const cacheKey = buildCacheKey(result.token);
  if (localStorage.getItem(PUSH_TOKEN_CACHE_KEY) === cacheKey) return;

  try {
    await http.post('/api/v1/user/device-token', {
      token: result.token,
      platform: result.platform,
    });
    localStorage.setItem(PUSH_TOKEN_CACHE_KEY, cacheKey);
  } catch (error) {
    console.error('Failed to register push token:', error);
  }
}

export async function unregisterPushToken() {
  if (!isApp()) return;

  try {
    await http.delete('/api/v1/user/device-token');
    localStorage.removeItem(PUSH_TOKEN_CACHE_KEY);
  } catch (error) {
    console.error('Failed to unregister push token:', error);
  }
}
